

export const isMobile = () : boolean => {
    const result = window.matchMedia('(max-width: 768px)').matches;
    return result;
}